import { useContext } from "react";
import { ProjectContext } from "@app/project-watcher";

export const useProjectId = () => {
	return useContext(ProjectContext);
};
